import React from "react";
import PropTypes from "prop-types";
import { DEV_MODE_WARNING_DISMISS_KEY, DEV_BANNER_HEIGHT } from "../../config/devAuth";

const DevModeWarning = ({ visible, onDismiss }) => {
  if (!visible) {
    return null;
  }

  const handleDismiss = () => {
    localStorage.setItem(DEV_MODE_WARNING_DISMISS_KEY, "true");
    if (onDismiss) {
      onDismiss();
    }
  };

  const containerStyles = {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    height: DEV_BANNER_HEIGHT,
    boxSizing: "border-box",
    backgroundColor: "#d9534f",
    color: "#ffffff",
    padding: "0 16px",
    textAlign: "center",
    fontWeight: "bold",
    fontSize: "14px",
    zIndex: 9999,
    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  };

  const buttonStyles = {
    position: "absolute",
    right: "16px",
    background: "transparent",
    border: "none",
    color: "#ffffff",
    fontSize: "18px",
    cursor: "pointer",
    padding: "0 8px",
    lineHeight: 1
  };

  return (
    <div style={containerStyles}>
      <span>DEV MODE: Auto-login enabled - DO NOT USE IN PRODUCTION</span>
      <button type="button" style={buttonStyles} onClick={handleDismiss} title="Dismiss" aria-label="Dismiss dev mode warning">
        &times;
      </button>
    </div>
  );
};

DevModeWarning.propTypes = {
  visible: PropTypes.bool,
  onDismiss: PropTypes.func
};

DevModeWarning.defaultProps = {
  visible: false,
  onDismiss: null
};

export default DevModeWarning;
